module.exports = __webpack_public_path__ + "img/43.c89ee2ef.jpg";